import {
    FETCH_PRODUCT_LOCALISATION,
    FETCH_PRODUCT_LOCALISATION_FAILURE,
    FETCH_PRODUCT_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const fetchProductLocalisation = (payload) => {
    return {
        type: FETCH_PRODUCT_LOCALISATION,
        payload: payload,
    };
};

export const fetchProductLocalisationFailure = (error, payload) => {
    return {
        type: FETCH_PRODUCT_LOCALISATION_FAILURE,
        error: error,
        payload: payload,
    };
};

export const fetchProductLocalisationSuccess = (payload, response) => {
    return {
        type: FETCH_PRODUCT_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-localisation/fetchProductLocalisation.js